import { useMutation } from "@tanstack/react-query";
import { App } from "antd";
import { handleError } from "api";
import { EventsApiService } from "features/events/api/events-api.service";
import { queryClient } from "providers";

import { eventsQueryKeys } from "./query-keys";

const { addupdatestrategicpartner } = EventsApiService();

export const useAddStratgeic = (id: any) => {
  const { message } = App.useApp();

  return useMutation({
    mutationFn: (payload: any) => {
      return addupdatestrategicpartner(payload);
    },

    onError: (error) => {
      const uiMessage = handleError(error);
      message.error(uiMessage);
    },

    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: eventsQueryKeys.all,
      });

      // ✅ CHECK DELETE FLAG
      if (variables?.isDelete) {
        message.success("Strategic partner removed successfully!");
      } else if (id) {
        message.success("Strategic partner updated successfully!");
      } else {
        message.success("Strategic partner created successfully!");
      }
    },
  });
};

export { addupdatestrategicpartner };
